import {
  Avatar,
  Box,
  Button,
  ButtonProps,
  Card,
  CardContent,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { ReactElement, useContext } from "react";
import { PageContext } from "../App/Context/PageContext";
import { useNavigate } from "react-router";
import { useLocalStorage } from "react-use";
import { Resource } from "../utils";
import { Page } from "../../api";
import { ActionType, AppContext, useRouterParams } from "@cdv/jazz-ui";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import { translateField } from "@cdv/jazz-i18n";
import RenderContent from "../Content/Content";
import AppBar from "../ui/AppBar";

export default function ContentShow(): ReactElement {
  const { pages } = useContext(PageContext);
  const { id } = useRouterParams();
  const navigate = useNavigate();
  const { getUrl } = useContext(AppContext);

  const page = pages?.find((p) => p.id === id);

  if (!page) {
    return (
      <Paper sx={{ m: 2, p: 3 }} variant="outlined">
        <Stack sx={{ alignItems: "center", justifyContent: "center" }} spacing={2}>
          <Avatar sx={{ width: 48, height: 48 }}>
            <SearchOffIcon />
          </Avatar>
          <Typography variant="body2">{translateField(Resource.Page, "404")}</Typography>
        </Stack>
      </Paper>
    );
  }

  return (
    <>
      <AppBar title={page.parrent ? page.parrent.name : page.name} />
      <Card sx={{ mx: "16px", mt: "0 !important", borderRadius: 0, boxShadow: "none" }}>
        <CardContent sx={{ mt: 0 }}>
          <RenderContent contentValue={page.content} />
        </CardContent>
      </Card>
      <Stack spacing={2}>
        {page.relatedPages?.map((relatedPage) => (
          <Button
            key={relatedPage.id}
            size="large"
            variant="contained"
            color={relatedPage.color?.toLowerCase() as ButtonProps["color"]}
            onClick={() =>
              navigate(getUrl(Resource.Page, ActionType.SHOW, { id: relatedPage.targetPage.id }))
            }
          >
            {relatedPage.name ? relatedPage.name : relatedPage.targetPage.name}
          </Button>
        ))}
      </Stack>
    </>
  );
}
